import { QuestionTextInput } from '../../../ui/input';
export default QuestionTextInput;